"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var ShowIfTranslationExists_1 = require("../../../../../common/components/ShowIfTranslationExists");
var core_1 = require("@material-ui/core");
var react_intl_1 = require("react-intl");
var staticDisclaimersStyles_1 = require("./staticDisclaimersStyles");
var StaticDisclaimer = function () {
    var intl = react_intl_1.useIntl();
    var styles = staticDisclaimersStyles_1.default({});
    return (<ShowIfTranslationExists_1.default translationKey="trans__checkout__enquiry_form__bottom_disclaimer">
      <core_1.Typography className={styles.disclaimer} dangerouslySetInnerHTML={{
        __html: intl.formatMessage({
            id: 'trans__checkout__enquiry_form__bottom_disclaimer',
        }),
    }}/>
    </ShowIfTranslationExists_1.default>);
};
exports.default = StaticDisclaimer;
